<template>
  <CardComponent>
    <v-responsive max-width="100%">
    <div class="tabs-component">
      <v-tabs
        v-model="tab"
        background-color="white"
        class=""
        height="56px"
        :hide-slider="true"
        show-arrows
      >
        <v-tab
          v-for="slot in slots"
          :key="slot.name"
        >
          {{ slot.title }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="slot in slots"
          :key="'item' + slot.name"
        >
          <v-card flat>
            <slot :name="slot.name"></slot>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
    </v-responsive>
  </CardComponent>
</template>

<script>
import {ref} from '@vue/composition-api'
import CardComponent from "@/components/form/CardComponent";

export default {
  name: "TabsComponent",
  components: {CardComponent},
  props: {
    slots: Array
  },
  setup() {
    const tab = ref(null)
    return {tab}
  }
}
</script>

<style scoped lang="scss">
.tabs-component {
  /* Styling for tab-list */
  .v-tab {
    border-top: 1px solid map-get($grey, 'lighten-blue-1');
    border-left: 1px solid map-get($grey, 'lighten-blue-1');
    background-color: map-get($grey, 'lighten-4');

    &--active {
      position: relative;
      z-index: 1;
      background-color: white;
      border-top: none;
      border-left: none;
      box-shadow: 0 6px 10px rgba(0,0,0, .16);

      + .v-tab {
        border-left: none;
      }
    }
  }

  /* Styling of the tab navigation without overflow, without controls */
  .v-slide-group:not(.v-slide-group--has-affixes) {
    > .v-slide-group__wrapper > .v-slide-group__content > .v-tab {
      &:first-child {
        border-top-left-radius: 5px;
      }

      &:last-child {
        &:not(.v-tab--active) {
          border-top-right-radius: 5px;
          border-right: 1px solid map-get($grey, 'lighten-blue-1');
        }
      }
    }
  }
}
</style>


<style lang="scss">
.tabs-component {
  max-width: 1000px;
  width: 100%;

  .navbar-vertical.show ~ #layout_default_content & {
    max-width: calc(1000px - 250px);
  }

  @media screen and (min-width: 1200px) {
    max-width: calc(100vw - 200px);

    // Change max-width if menu is open
    .navbar-vertical.show ~ #layout_default_content & {
      max-width: calc(100vw - 450px);
    }
  }

  /* Overwrite non-active font-color */
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active),
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon,
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn,
  .theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
    color: map-get($grey, 'lighten-blue-1');
  }

  .v-slide-group {
    /* Style next and prev buttons */
    &__next {
      border-top: 1px solid map-get($grey, 'lighten-blue-1');
      border-left: 1px solid map-get($grey, 'lighten-blue-1');
      border-right: 1px solid map-get($grey, 'lighten-blue-1');
      border-top-right-radius: 5px;
      background-color: map-get($grey, 'lighten-4');
    }

    &__prev {
      border-top: 1px solid map-get($grey, 'lighten-blue-1');
      border-left: 1px solid map-get($grey, 'lighten-blue-1');
      border-right: 1px solid map-get($grey, 'lighten-blue-1');
      border-top-left-radius: 5px;
      background-color: map-get($grey, 'lighten-4');
    }

    /* Styling for icon next / prev */
    .v-icon.v-icon {
      color: map-get($grey, 'lighten-blue-1');

      &.v-icon--disabled {
        opacity: 0.5;
      }
    }
  }

  /* Overwrite card styling inside tab-items */
  .v-tabs-items {
    .v-card,
    .v-sheet.v-card:not(.v-sheet--outlined) {
      box-shadow: none;
      margin-top: 0;
    }
  }
}
</style>
